var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalud2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salud_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.834,
    height: 138.533,
    viewBox: "0 0 163.834 138.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M2.971,103.9A3.2,3.2,0,1,0,4.2,99.983,3.231,3.231,0,0,0,2.971,103.9Z",
    transform: "translate(-1.97 -71.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M132.786,56.521q.474-1.214.867-2.416a45.807,45.807,0,0,0,2.217-16.749c-.465-9.739-4.973-19.1-12.692-26.368C115.755,4,106.337,0,97.33,0,83.912,0,73.422,7.481,68.365,11.958a.986.986,0,0,1-1.3.014C61.821,7.5,51.1,0,38.212,0,27.548,0,16.205,5.749,8.6,15.006a3.2,3.2,0,0,0,4.954,4.062C19.976,11.254,29.424,6.4,38.212,6.4c10.844,0,20.132,6.542,24.7,10.443a7.431,7.431,0,0,0,9.7-.089C76.991,12.875,86.028,6.4,97.341,6.4c14.463,0,31.281,13.363,32.14,31.25a39.451,39.451,0,0,1-1.912,14.438c-.357,1.108-.765,2.181-1.225,3.275q-1.939-.183-3.9-.186A41.567,41.567,0,0,0,81.077,96.851q0,1.629.125,3.231c-3.167,2.582-5.738,4.693-7.888,6.514a8.636,8.636,0,0,1-11.2,0c-2.9-2.46-6.68-5.541-10.675-8.791C37.01,86.054,17.255,69.956,12.5,61.874A44.759,44.759,0,0,1,6.619,46.733c-.1-.579-.191-1.169-.277-1.751A3.2,3.2,0,1,0,0,45.813c.086.679.192,1.366.311,2.039A50.875,50.875,0,0,0,6.984,65.11c5.336,9.079,24.784,24.936,40.41,37.659,3.97,3.236,7.722,6.295,10.578,8.714a15.017,15.017,0,0,0,19.475,0c1.438-1.216,3.075-2.574,4.962-4.12a41.41,41.41,0,1,0,50.376-50.855ZM122.44,132.133a35.275,35.275,0,1,1,34.966-35.273A35.159,35.159,0,0,1,122.44,132.133Z",
    transform: "translate(0.031 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M398.849,279.684h-4.4v-4.464a7.112,7.112,0,0,0-7.087-7.121h-7.683a7.112,7.112,0,0,0-7.087,7.121v4.464h-4.4a7.109,7.109,0,0,0-7.087,7.118v7.758a7.109,7.109,0,0,0,7.087,7.118h4.4v4.466a7.11,7.11,0,0,0,7.087,7.118h7.683a7.112,7.112,0,0,0,7.087-7.118v-4.472h4.4a7.11,7.11,0,0,0,7.087-7.118V286.8A7.112,7.112,0,0,0,398.849,279.684Zm.687,14.87a.7.7,0,0,1-.687.718h-7.6a3.2,3.2,0,0,0-3.2,3.2v7.666a.7.7,0,0,1-.687.718h-7.683a.7.7,0,0,1-.687-.718v-7.666a3.2,3.2,0,0,0-3.2-3.2h-7.6a.7.7,0,0,1-.687-.718V286.8a.7.7,0,0,1,.687-.718h7.6a3.2,3.2,0,0,0,3.2-3.2v-7.658a.7.7,0,0,1,.687-.72h7.683a.7.7,0,0,1,.687.72v7.664a3.2,3.2,0,0,0,3.2,3.2h7.6a.7.7,0,0,1,.687.718Z",
    transform: "translate(-261.05 -193.819)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalud2);
export default __webpack_public_path__ + "static/media/Salud2.77e29c36ac1a34729ab1f547fd293f4b.svg";
export { ForwardRef as ReactComponent };